<template>
    <div class="auth-wrapper d-flex no-block justify-content-center align-items-center" style="">
        <div class="auth-box">
            <div>
                <div class="logo">
                    <span class="db"><img alt="logo" src="../../assets/images/logo/Borlaug_CX_High.png"/></span>
                    <p></p>
                    <h5 class="font-medium m-b-20">Welcome back!</h5>
                    <p></p>
                </div>
                <!-- Form -->
                <div class="row">
                    <div class="col-12">
                        <form @submit.prevent="handleSubmit" class="form-horizontal m-t-20">
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="ti-pencil"></i></span>
                                </div>
                                <input :class="{'is-invalid': submitted && errors.has('oldPass')}" aria-describedby="Password"
                                       aria-label="Password"
                                       class="form-control form-control-lg"
                                       data-vv-as="Old Password"
                                       id="oldPass"
                                       name="oldPass"
                                       placeholder="Old Password"
                                       type="password"
                                       v-model="credentials.oldPass"
                                       v-validate="'required'">
                                <div class="invalid-feedback" v-if="submitted && errors.has('oldPass')">{{
                                    errors.first('oldPass') }}
                                </div>
                            </div>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="ti-pencil"></i></span>
                                </div>
                                <input :class="{'is-invalid': submitted && errors.has('newPass')}" aria-describedby="Password"
                                       aria-label="Password"
                                       class="form-control form-control-lg"
                                       data-vv-as="New Password"
                                       id="newPass"
                                       name="newPass"
                                       ref="newPass"
                                       placeholder="New Password"
                                       type="password"
                                       v-model="credentials.newPass"
                                       v-validate="'required|min:8'">
                                <div class="invalid-feedback" v-if="submitted && errors.has('newPass')">{{
                                    errors.first('newPass') }}
                                </div>
                            </div>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="ti-pencil"></i></span>
                                </div>
                                <input :class="{'is-invalid': submitted && errors.has('password')}" aria-describedby="Password"
                                       aria-label="Password"
                                       class="form-control form-control-lg"
                                       data-vv-as="Password"
                                       id="password"
                                       name="password"
                                       placeholder="Confirm Password"
                                       type="password"
                                       v-model="credentials.confPass"
                                       v-validate="'required|min:8|confirmed:newPass'">
                                <div class="invalid-feedback" v-if="submitted && errors.has('password')">{{
                                    errors.first('password') }}
                                </div>
                            </div>
                            <div class="form-group text-center">
                                <div class="col-xs-12 p-b-20">
                                    <button class="btn btn-block btn-lg btn-acrecx" type="submit">Submit</button>
                                </div>
                            </div>
                            <div class="form-group m-b-0 m-t-10">
                                <div class="col-sm-12 text-center">
                                    Return to Dashboard?
                                    <router-link :to="{ name: 'dashboard'}" class="text-info m-l-5"><b>Click Here !</b></router-link>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "ChangePassword",
        props: ['token'],
        computed: {
            ...mapGetters(["currentUser"])
        },
        data() {
            return {
                submitted: false,
                loading: false,
                credentials: {
                    email: '',
                    oldPass: '',
                    newPass: '',
                    confPass: ''
                },
                resetCredential: {
                    password: '',
                    confirmPassword: ''
                },
                loggingIn: false,
                error: '',
                is_bws_token_exist: false
            }
        },
        mounted() {
            this.is_bws_token_exist = JSON.stringify(localStorage.getItem('bws_token')) !== 'null' ? true : false;
            this.init();
        },
        methods: {
            init() {
                $('[data-toggle="tooltip"]').tooltip();
                $(".preloader").fadeOut();

                $('#to-recover').on("click", function () {
                    $("#notifyform").slideUp();
                    $("#recoverform").fadeIn();
                });
            },
            handleSubmit() {
                this.submitted = true;
                this.$validator.validate()
                    .then(valid => {
                        if (valid) {
                            this.changePassword()
                        }
                    })
            },
            async changePassword() {
                if (this.credentials.newPass === this.credentials.confPass) {
                    delete this.credentials.confPass;
                    try {
                        this.credentials.email = this.currentUser.email;
                        await this.$http.post(`/changePassword`, this.credentials);
                        if(this.is_bws_token_exist) {
                            await this.$accounts.patch(`/accounts/user`, {
                                password: this.credentials.newPass
                            });
                        }
                        await this.$swal('Success', 'Password changed successfully. Please Re-Login.', 'info');
                        this.$store.commit("LOGOUT");
                        await this.$router.replace("/auth/login");
                    } catch (e) {
                        this.$toastr('error', e.response.data.reason, 'Failed');
                    }
                } else {
                    this.$toastr.e('Password and Confirm Password Mismatch', 'Error');
                }
            },
            // async resetPassword() {
            //     if(this.resetCredential.password === this.resetCredential.confirmPassword) {
            //         try {
            //             let response = await this.$truvito.post(`/changePassword/${this.token}`, {newPass: this.resetCredential.password});
            //             this.$swal('Success', 'Password changed successfully. Please Re-Login.', 'info');
            //             this.$store.commit("LOGOUT");
            //             this.$router.replace("/auth/login");
            //         } catch(err) {
            //             console.log(err);
            //         }
            //     } else {
            //         this.$toastr.e('Password and Confirm Password Mismatch', 'Error');
            //     }
            // }
        }
    }
</script>

<style scoped>
    .auth-wrapper {
        background: linear-gradient(0deg, rgba(54, 64, 78, 0.75), rgba(54, 64, 78, 0.75)), url(../../assets/images/big/farmer.jpg);
        background-size: cover;
    }
</style>
